import TotalPriceConnector from '../TotalPrice/totalPrice.props';
import SimpleTotalPriceComponent from './simpleTotalPrice.component';

export default TotalPriceConnector(SimpleTotalPriceComponent);
